"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDomainOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
/** Resolve an Unstoppable domain and get the address. */
exports.resolveDomainOperation = {
    method: 'GET',
    name: 'resolveDomain',
    id: 'resolveDomain',
    groupName: 'resolve',
    isNullable: true,
    urlPathPattern: '/resolve/{domain}',
    urlPathParamNames: ['domain'],
    urlSearchParamNames: ['currency'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams(request) {
    return {
        currency: request.currency,
        domain: request.domain,
    };
}
function serializeRequest(request) {
    return {
        currency: request.currency,
        domain: request.domain,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        currency: jsonRequest.currency,
        domain: jsonRequest.domain,
    };
}
function deserializeResponse(jsonResponse, request, core) {
    return {
        address: dataTypes_1.EvmAddress.create(jsonResponse.address, core),
    };
}
//# sourceMappingURL=resolveDomainOperation.js.map